// @TODO: convert to enum
export const LOAD_STATE = {
    LOADING: 'loading',
    FAIL: 'fail',
    SUCCESS: 'success',
    CANCELED: 'canceled',
};
